<!-- Minimized tray — small dock, not the full card -->
<div class="sg-tray" *ngIf="visible && collapsed" (click)="toggleCollapse()">
  <span class="sg-tray__badge" *ngIf="!justCompleted">{{ doneCount }}/{{ steps.length }}</span>
  <span class="sg-tray__badge sg-tray__badge--done" *ngIf="justCompleted">🎉</span>
</div>

<div class="sg-widget" *ngIf="visible && !collapsed">

  <div class="sg-widget__header" (click)="toggleCollapse()">
    <span class="sg-widget__title">Setup guide</span>
    <div class="sg-widget__actions">
      <span class="sg-widget__badge" *ngIf="!justCompleted">{{ doneCount }}/{{ steps.length }}</span>
      <ion-icon name="chevron-down-outline"></ion-icon>
      <ion-icon name="close-outline" (click)="dismiss($event)"></ion-icon>
    </div>
  </div>

  <div class="sg-widget__footer" *ngIf="justCompleted">
    <div class="sg-widget__footer-icon">🎉</div>
    <div>
      <strong>You're all set!</strong>
      <div class="sg-widget__footer-sub">Setup complete — nice work.</div>
    </div>
  </div>

  <div class="sg-widget__cta" *ngIf="justCompleted && isPaidPlan" (click)="startPaymentsGuide()">
    <span>Complete payment setup to keep going</span>
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </div>

  <div class="sg-widget__list" *ngIf="!justCompleted">
    <div
      class="sg-row"
      *ngFor="let step of steps"
      [class.done]="isDone(step)"
      (click)="onStepClick(step)">
      <span class="sg-row__dot"></span>
      <span class="sg-row__label">{{ step.label }}</span>
      <ion-icon *ngIf="!isDone(step)" name="chevron-forward-outline" class="sg-row__chev"></ion-icon>
    </div>
  </div>

</div>
